import {Action} from "redux";
import {isQueryFormAction, QueryFormAction} from "./actions";
import {categoryManagerReducer, CategoryManagerState} from "../../../lib/category-manager/reducers";
import {isCategoryManagerAction} from "../../../lib/category-manager/actions";
import {ErrorField} from "./data";

export type State = {
	queryId: number|string
	title: string
	submitting: boolean
	errorFields?: ErrorField[]
	categoryManagerState: CategoryManagerState
}

export const reducer = (s: State, a: Action): State => {
	if(isQueryFormAction(a)) {
		return queryFormReducer(s, a.action)
	} else if(isCategoryManagerAction(a)) {
		return {...s, categoryManagerState: categoryManagerReducer(s.categoryManagerState, a.action)}
	}
	return s
}

const queryFormReducer = (s: State, a: QueryFormAction): State => {
	switch (a.type) {
		case "set title":
			return {...s, title: a.title}
		case "set failure":
			return {...s, errorFields: a.errorFields}
		case "set submitting":
			return {...s, submitting: a.submitting}
	}
}



// WEBPACK FOOTER //
// ./src/contacts/saved-queries/query-form/reducers.ts